import axios from "axios";
import { useAddress } from "../AddressContext";
import Frame421 from "./boxOne/Frame421";
import PaymentCheckout from "./boxTwo/PaymentCheckout";
import { createContext, useState, useMemo, useEffect } from "react";
import { link } from "../../../config";

export const leftBoxContext = createContext();

function FrameLeft({
  cartItems = [],
  totalPrice = 0,
  fees = 0,
  checkoutPayment,
  setCheckoutPayment,
  couponCode,
  ProductItems = [],
}) {
  // State for user information
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [area, setArea] = useState("");
  const [address, setAddress] = useState("");
  const [house, setHouse] = useState("");

  // State for handling selected address
  const [shippingType, setShippingType] = useState("");
  const [shippingCostVendor, setShippingCostVendor] = useState(0);
  const [shippingCostOrder, setShippingCostOrder] = useState(0);
  const [shippingCostArea, setShippingCostArea] = useState(0);
  const { selectedAddress, setSelectedAddress } = useAddress();
  const handleAddressSelect = (address) => {
    setSelectedAddress(address);
  };

  // Fetch shipping type
  useEffect(() => {
    const fetchShippingExpenses = async () => {
      try {
        const { data } = await axios.get(`${link}shipping-control`);
        setShippingType(data?.data?.name);
      } catch (error) {
        console.log(error);
      }
    };

    fetchShippingExpenses();
  }, []);

  // Fetch shipping costs based on shipping type and selected address
  useEffect(() => {
    const getShippingExpenses = async () => {
      const area = selectedAddress?.area;
      if (shippingType === "order") {
        const { data: shippingCostOrder } = await axios.get(
          `${link}order-flat-rate`
        );
        setShippingCostOrder(shippingCostOrder?.flatRate || 0);
      } else if (shippingType === "vendor") {
        const { data: shippingCostVendor } = await axios.get(
          `${link}vendor-flat`
        );
        setShippingCostVendor(shippingCostVendor?.cost || 0);
      } else if (shippingType === "area") {
        if (area) {
          try {
            const { data: areaCost } = await axios.get(
              `${link}areas-flat/by-name?name=${area}`
            );
            setShippingCostArea(areaCost?.data?.cost || 0);
          } catch (err) {
            console.error("Failed to fetch area shipping cost:", err);
            setShippingCostArea(0);
          }
        } else {
          setShippingCostArea(0);
        }
      }
    };

    getShippingExpenses();
  }, [shippingType, selectedAddress]);

  // Calculate totals using useMemo for optimization
  const {
    productTotal,
    shippingTotal,
    taxTotal,
    totalTodayDiscount,
    totalFlashDiscount,
    finalPriceWithDiscountAndFees,
  } = useMemo(() => {
    let productTotal = 0;
    let shippingTotal = 0;
    let taxTotal = 0;
    let totalTodayDiscount = 0;
    let totalFlashDiscount = 0;

    ProductItems.forEach((item, index) => {
      const quantity = cartItems[index]?.quantity || 0;
      const priceAfterDiscount = item?.price_after || 0;
      const shippingCost = item?.shipping_cost || 0;
      const taxFlat = item?.tax_Flat || 0;

      // Calculate discounts
      const todayDiscount = (item.todayDiscount || []).reduce(
        (sum, discount) => sum + discount.discount,
        0
      );
      const flashDiscount = (item.flashDiscount || []).reduce(
        (sum, discount) => sum + discount.discount,
        0
      );

      // Accumulate totals
      productTotal += priceAfterDiscount * quantity;
      shippingTotal += shippingCost * quantity;
      taxTotal += taxFlat * quantity;
      totalTodayDiscount += todayDiscount * quantity;
      totalFlashDiscount += flashDiscount * quantity;
    });

    // Calculate final price
    const finalPriceWithDiscountAndFees =
      productTotal +
      shippingTotal +
      shippingCostVendor +
      shippingCostOrder +
      shippingCostArea +
      taxTotal -
      totalTodayDiscount -
      totalFlashDiscount;

    return {
      productTotal,
      shippingTotal,
      taxTotal,
      totalTodayDiscount,
      totalFlashDiscount,
      finalPriceWithDiscountAndFees,
    };
  }, [ProductItems, cartItems, shippingCostVendor, shippingCostOrder, shippingCostArea]);

  return (
    <div className="frame-left flex-grow-1 ps-4 w-100">
      <leftBoxContext.Provider
        value={{
          selectedAddress,
          handleAddressSelect,
          setSelectedAddress,
          name,
          setName,
          phone,
          setPhone,
          city,
          setCity,
          area,
          setArea,
          address,
          setAddress,
          house,
          setHouse,
          totalPrice,
          cartItems,
        }}
      >
        {checkoutPayment ? (
          <PaymentCheckout
            couponCode={couponCode}
            fees={fees}
            checkoutPayment={checkoutPayment}
            setCheckoutPayment={setCheckoutPayment}
            finalPriceWithDiscountAndFees={finalPriceWithDiscountAndFees}
          />
        ) : (
          <Frame421
            fees={fees}
            cartItems={cartItems}
            setCheckoutPayment={setCheckoutPayment}
          />
        )}
      </leftBoxContext.Provider>
    </div>
  );
}

export default FrameLeft;